import { createModel } from 'hox';
import { useState, useEffect, Key } from 'react';
import { ISaleDetail, ISaleDetailsList } from './bmsBillBusSoType';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants';
import { busBusinesstService } from './bmsBillBusSoService';
import { useBmsSaleRoDetailModel } from '../bmsBillSaleRo/bmsBillSaleRoModel';
import moment from 'moment';
export type ISaleDesc = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	discountAll: number;
	receivableAll: number;
	[key: string]: any;
};
export const useBmsBusSoDetailModel = createModel(function () {
	const initDesc: ISaleDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
		discountAll: 0, //折扣,
		receivableAll: 0, //应收
	};
	const initForm = {};
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const initMaterialSearchParam = {};
	const { getBmsTreeNodeName } = useBmsSaleRoDetailModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<ISaleDetail>({});
	//查看维修用料详情列表
	const [detailMaterialLookList, setDetailMaterialLookList] = useState<ISaleDetailsList[]>([]);
	const [lookDesc, setLookDesc] = useState<ISaleDesc>(initDesc);
	useEffect(() => {
		let newDesc: ISaleDesc = initDesc;
		detailMaterialLookList &&
			detailMaterialLookList.forEach((item, index) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.partsCost);
				newDesc.discountAll += Number(item.partsCost) - Number(item.amount);
				newDesc.receivableAll += Number(item.amount);
			});
		if ('favorableAmount' in detailLookForm) {
			newDesc.receivableAll = newDesc.receivableAll - Number(detailLookForm.favorableAmount);
			newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount);
		}
		newDesc.itemNumAll = detailMaterialLookList && detailMaterialLookList.length;
		setLookDesc(newDesc);
	}, [detailLookForm, detailMaterialLookList]);

	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await busBusinesstService.saleOne(id);
		if (retData) {
			const { item, deliveryTime, enterTime, settleDetails, ...from } = retData;
			const newMaterialDetails = item?.map((item) => {
				return {
					...item,
					detailsId: item.id,
				};
			});
			const newFrom = {
				...from,
				enterTime: enterTime ? moment(enterTime) : null,
				deliveryTime: deliveryTime ? moment(deliveryTime) : null,
				customerTypeName: getBmsTreeNodeName(from.customerTypeCode as string),
				settlementPartyName: getBmsTreeNodeName(from.settlementPartyCode as string),
				payType: getBmsTreeNodeName(from.payType as string),
				productTypeName: getBmsTreeNodeName(from.productTypeCode as string),
				invoiceTypeName: getBmsTreeNodeName(from.invoiceTypeCode as string),
				serviceTypeName: getBmsTreeNodeName(from.serviceTypeCode as string),
			};
			setDetailLookForm(newFrom);
			setDetailMaterialLookList((newMaterialDetails as ISaleDetailsList[]) ?? []);
		}
	};
	//关闭页签清不同状态缓存
	const resetLookCatch = async (type?: string) => {
		setDetailLookForm(initForm);
		setDetailMaterialLookList([]);
	};
	return {
		initForm,
		initPgCfg,
		initMaterialSearchParam,
		detailLookForm,
		detailMaterialLookList,
		lookDesc,
		setDetailLookForm,
		setDetailMaterialLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
	};
});
